module.exports = __webpack_public_path__ + "img/icon.49ac880c.svg";